// extracted by mini-css-extract-plugin
module.exports = {"spinner":"loading-circle_spinner__2Cbf8","spin":"loading-circle_spin__T1H6D"};